<template>
    <b-container>

        <b-card v-if="wardId!==null && organizationCode!==null && isInRole('canModifyOrganizations')">
          <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'ward-organizations', params: { wardId: wardId}}">Back to Ward Organizations</b-breadcrumb-item>
            <b-breadcrumb-item active>{{organizationDetails.org_name}}</b-breadcrumb-item>
          </b-breadcrumb>
          <b-overlay
            id="overlay-background"
            :show="show">
            <h3 class="mb-3">Organization Name: {{organizationDetails.org_name}}</h3>
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
              <b-dropdown text="Actions" v-if="wardId!==null">
                <b-dropdown-item :to="{name: 'ward-organization', params: { 'wardId': wardId, 'orgCode': this.organizationCode}}"><font-awesome-icon icon="edit" /> Edit Organization</b-dropdown-item>
                <div v-if="!organizationDetails.primary">
                <b-dropdown-item v-on:click="traverseAndTakeAction('ADD')"><font-awesome-icon icon="plus" /> Add Filtered Contacts To Group</b-dropdown-item>
                <b-dropdown-item v-on:click="traverseAndTakeAction('REMOVE')"><font-awesome-icon icon="minus-square" /> Remove Filtered Contacts From Group</b-dropdown-item>
                </div>
                <div v-if="organizationDetails.primary">
                <b-dropdown-item v-on:click="traverseAndTakeAction('SWITCH')"><font-awesome-icon icon="exchange-alt" /> Switch Filtered Contacts To Group</b-dropdown-item>
                </div>
                <div v-if="totalUpdates >0">
                  <b-dropdown-item v-on:click="sendUpdatesToServer"><font-awesome-icon icon="save" /> Submit Contact Updates</b-dropdown-item>
                </div>
                <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item :to="{name: 'ward-notification', params: { 'wardId': wardId, 'stakeId': stakeId, 'orgCode': this.organizationCode}}"><font-awesome-icon icon="sms" /> Send a New Message</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item :to="{name: 'ward-message-list', params: { 'wardId': wardId, 'stakeId': stakeId, 'initOrg': this.organizationCode, 'initMessageState': 'SENT'}}"><font-awesome-icon icon="eye" /> Sent Messages</b-dropdown-item>
              <b-dropdown-item :to="{name: 'ward-message-list', params: { 'wardId': wardId, 'stakeId': stakeId, 'initOrg': this.organizationCode, 'initMessageState': 'PENDING'}}"><font-awesome-icon icon="eye" /> Pending Messages</b-dropdown-item>
              </b-dropdown>
                    </b-col>
                  </b-row>
        <b-row class="mb-3 mt-3">
            <b-col cols="9">
              <b-form-group
                    id="input-group-2"
                    description="Text to search organization contacts"
                    >
                <b-form-input v-model="searchRequest.search_term" placeholder="Enter text to search"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col  align="right">
                 <b-form-group
                    id="input-group-2"
                    >
                <b-button variant="primary" @click="filterWard()"><font-awesome-icon icon="search" /> Search</b-button>
                 </b-form-group>
            </b-col>
        </b-row>
            <b-row>
              <b-col>
              <b-form-group
                    id="current-organization-contacts"
                    description="Organization Filter"
                    >
                <b-form-select v-model="orgSelected" :options="active_organizations" @change="filterWard()"></b-form-select>
              </b-form-group>
              </b-col>
              <b-col>
                 <b-form-group
                    id="input-group-2"
                    description="How to search"
                    >
                    <b-form-select v-model="searchRequest.operator" :options="searchOperators"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                    id="input-group-2"
                    description="Field to search in"
                    >
                    <b-form-select v-model="searchRequest.field_name" :options="contactFields"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
              </b-col>
              <b-col>
                <h6>Status: <b-badge :variant="(organizationDetails.disabled)?'secondary':'info'">{{(organizationDetails.disabled)?'DISABLED':'ENABLED'}}</b-badge></h6>
                <h6>Type: <b-badge :variant="(organizationDetails.primary)? 'success' : 'secondary'">{{(organizationDetails.primary) ? 'PRIMARY': 'AUXILARY'}}</b-badge></h6>
                <h6>Organization Code: {{organizationDetails.org_code}}</h6>
                <h6>Greeting Language: {{getLanguageInfo(organizationDetails.greeting_language)}}</h6>
                <h6>Alternate Message Languages: {{(organizationDetails.message_languages.length > 0 ? flattenLanguages(organizationDetails.message_languages): 'None')}}</h6>
                <h6>Organizations Included: {{(organizationDetails.composite_orgs.length > 0) ? flattenAuxOrganizations(organizationDetails.composite_orgs) : 'None'}}</h6>
                <h6>Selected Contacts: <b-badge :variant="(totalUpdates > 0) ? 'success' : 'secondary'">{{ totalUpdates }}</b-badge> <b-button
                    v-if="totalUpdates > 0"
                    v-on:click="clearQueue"
                    variant="outline-secondary">
                    <font-awesome-icon icon="trash" />
                  Clear
                </b-button></h6>

              </b-col>
            </b-row>
        </b-overlay>
        <b-row>
        <b-col>
        <b-table
            :fields="table.fields"
            :items="table.items"
            :busy="table.isBusy"
            :tbody-tr-class="rowClass"
            class="mb-3"
            light
            responsive
            show-empty
            empty-text="No Contacts to show"
            outlined>
            <template #cell(consent_state)="row">
                <span title="Unsubscribed"
                      v-b-tooltip.hover.v-danger
                      v-if="row.item.disabled && row.item.consent_state==='UNSUBSCRIBED'">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                </span>
                <span title="Disabled"
                      v-b-tooltip.hover.v-warning
                      v-if="row.item.disabled && row.item.consent_state!=='UNSUBSCRIBED'">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                </span>
                <span title="Enrolled"
                      v-b-tooltip.hover
                      v-if="!row.item.disabled && row.item.consent_state=='ENROLLED'">
                  <font-awesome-icon :icon="['fas', 'check-circle']" />
                </span>
            </template>
            <template #cell(full_name)="row">
                {{row.item.first_name}} {{row.item.last_name}}
            </template>
            <template #cell(phone_number)="row">
                {{formatPhoneNumber(row.item.phone_number)}}
            </template>
            <template #cell(primary_organization)="row">
                  {{getOrganizationInfo(row.item.primary_organization).text}}
              </template>
            <template #cell(Action)="row">
              <!--
                <b-button
                    :key="row.item.uid"
                    :to="{name: 'ward-contact-notes', params: { 'wardId': wardId, 'contactId': row.item.contact_id, 'stakeId': row.item.stake_id}}"
                    :variant="isInRole('canModifyContact') && !row.item.disabled ? 'outline-secondary': 'danger'">
                <font-awesome-icon icon="eye" />
                </b-button>
                -->
                <b-dropdown id="dropdown-1" text="Action" v-if="organizationDetails.primary">
                  <div v-if="!inContactsToUpdate(row.item.contact_id).exists">
                  <b-dropdown-item :disabled="inContactsToUpdate(row.item.contact_id).exists" v-if="!alreadyBelongToOrganization(row.item).already_belongs" v-on:click="addForUpdate(row.item, 'SWITCH')">Switch To {{organizationDetails.org_name}}</b-dropdown-item>
                  <b-dropdown-item disabled v-if="alreadyBelongToOrganization(row.item).already_belongs">Belongs to Group</b-dropdown-item>
                  </div>
                  <b-dropdown-item v-if="inContactsToUpdate(row.item.contact_id).exists" v-on:click="removeFromQueue(row.item)">Unselect</b-dropdown-item>
                </b-dropdown>
                <b-dropdown id="dropdown-1" text="Action" v-if="!organizationDetails.primary">
                  <div v-if="!inContactsToUpdate(row.item.contact_id).exists">
                  <b-dropdown-item :disabled="inContactsToUpdate(row.item.contact_id).exists" v-if="!alreadyBelongToOrganization(row.item).already_belongs" v-on:click="addForUpdate(row.item, 'ADD')">Add To Group</b-dropdown-item>
                  <b-dropdown-item :disabled="inContactsToUpdate(row.item.contact_id).exists" v-if="alreadyBelongToOrganization(row.item).already_belongs && !alreadyBelongToOrganization(row.item).implicit_belongs" v-on:click="addForUpdate(row.item, 'REMOVE')">Remove From Group</b-dropdown-item>
                  <b-dropdown-item disabled v-if="alreadyBelongToOrganization(row.item).implicit_belongs">Implicit Belongs To Group</b-dropdown-item>
                  </div>
                  <b-dropdown-item v-if="inContactsToUpdate(row.item.contact_id).exists" v-on:click="removeFromQueue(row.item)">Unselect</b-dropdown-item>
                </b-dropdown>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
                        <template #cell(show_details)="row">
                          <b-button size="sm" @click="row.toggleDetails" class="mr-2" v-if="getContactOrganizationBreakdown(row.item).all_aux_orgs_counts > 0 ">
                            {{ row.detailsShowing ? 'Hide' : 'Show'}} ({{getContactOrganizationBreakdown(row.item).all_aux_orgs_counts}})
                          </b-button>

                        </template>
                        <template #row-details="row">
                          <b-card>
                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Primary Organization/Group:</b></b-col>
                              <b-col><pre>{{ getOrganizationInfo(row.item.primary_organization).text}}</pre></b-col>
                            </b-row>

                            <b-row class="mb-2">
                              <b-col sm="3" class="text-sm-right"><b>Auxilary Organizations/Groups:</b></b-col>
                              <b-col><pre>{{ (getContactOrganizationBreakdown(row.item).all_aux_orgs_counts > 0) ? getContactOrganizationBreakdown(row.item, '\n').pretty_print:''}}</pre></b-col>
                            </b-row>
                          </b-card>
                        </template>
        </b-table>
        </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
        <b-button-group v-if="pages.length>1">
            <b-button @click="searchWard(currentPage-1)">Prev</b-button>
            <b-button @click="searchWard(currentPage+1)">Next</b-button>
        </b-button-group>
            </b-col>
        </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { OrganizationApi } from "@/app/organizations/organizationApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
import { organizationMixin } from "@/mixins/organizationMixin";
import { contactMixin } from "@/mixins/contactMixin";

export default {
    name: "OrganizationContacts",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        organizationCode: {
          type: String,
          required: false,
          default: null
        }

    },
    mixins: [userMixin, organizationMixin, contactMixin],
    data () {
        return {
            stakeId: null,
            ward : {
                ward_id: null,
                families: [],
                stake: {},

            },
            organizationDetails : {
              org_code: null,
              org_name: null,
              composite_orgs: [],
              message_languages: [],
          },
            nextPage : {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
                org_filter: null
            },
            prevPage: {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null,
                org_filter: null
            },
            pages:[],
            currentPage: 0,
            lastPage:0,
            orgSelected : "WARD",
            searchTerm : null,
            //organizations : [],
            //aux_organizations:[],
            table: {
                id: "ward-list",
                fields: [
                    {
                        key: "consent_state",
                        label: "Status"

                    },
                    {
                        key: 'full_name',
                        label: 'Name'
                    },
                    {
                        key: "phone_number",
                        label: "Phone Number"
                    },
                    {
                        key: 'primary_organization',
                        label: 'Primary Org/Group'

                    },
                    {
                        key: "show_details",
                        label: "Aux Orgs/Groups"

                    },
                    {
                        key: "Action",
                        label: "Action"
                    }
                ],
                items: [],
                isBusy:false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }
            },
            stake: {
                stake_id: null
            },
            wardName: null,
            stakeName: null,
            show: false,
            contactFields: [],
            searchOperators: [],
            languageOptions: [],
            searchRequest: {
              field_name: 'all',
              operator: 'contains',
              page_size: 10,
              search_term: null
            },
          expandedCompositeOrgs: [],
          showAdvanceSearch: false
        }
    },
    async mounted() {
        //this.ward = await this.searchWard();
        if (this.$store.state.organizations.selectedSearchOrgFilter!==null) {
            this.orgSelected = this.$store.state.ward.selectedSearchOrgFilter;
        }
        this.searchOperators = this.$store.state.frontEndSettings.search_operators;
        this.contactFields = this.$store.state.frontEndSettings.contact_fields;
        this.languageOptions = this.$store.state.frontEndSettings.application_languages;
        this.orgSelected = this.organizationCode;
        this.show = true;
        this.pages.push(this.nextPage);
        await this.searchWard(0);
        await this.$store.dispatch('organizations/saveSearchOrgFilter', this.orgSelected);
        this.show = false;
        // fetch organizations
        await this.getOrganizations(this.wardId);
        await this.getOrganization();

    },
    methods: {
        async searchWard(page) {
            if(page < 0){
                return;
            }
            if(page > this.pages.length-1){
                return;
            }
            const payload = this.pages[page];
            payload.org_filter = this.orgSelected;
            payload.search_term = this.searchRequest.search_term;
            payload.field_name = this.searchRequest.field_name;
            payload.operator = this.searchRequest.operator;
            this.table.isBusy = true;
            try{
                const { data } = await WardApi.getWardList(this.wardId, payload);
                this.ward = data.ward;
                this.stake = data.stake;
                this.wardName = data.ward.ward_name;
                this.stakeName = data.stake.stake_name;
                if(data.last_evaluated_key !== null){
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.contact_list;
                this.table.isBusy = false;
                this.currentPage = page;
            }catch (e) {
                handleError(e, "Failed to fetch ward list");
            }finally{
                this.table.isBusy = false;
            }

        },
        async filterWard() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchWard(0);
            this.$store.dispatch('organizations/saveSearchOrgFilter', this.orgSelected);


        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;

        },
        getOrganizationInfo(value) {
            var i;
            for (i=0; i < this.all_organizations.length; i++) {
                if(this.all_organizations[i].value==value)
                    return this.all_organizations[i];
            }
        },
        getLanguageInfo(value) {
          // get language information
          let info = '';
          this.languageOptions.forEach(x=> {
            if (x.value===value) {
              info = x.text;
            }
          });
          return info;

        },
        flattenInAuxCompositeOrgs(primary_org) {
            let orgs = [];
            this.aux_organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        let org_name = (x.disabled) ? `${x.text}[Disabled]`:`${x.text}`;
                        orgs.push(org_name);
                    }
                }
            });
            return orgs.length >0 ? orgs.join('\n' ) : null ;
        },
        countInAuxCompositeOrgs(primary_org)
        {
            let orgs = [];
            this.all_organizations.forEach(x=>{
                if (x.composite_orgs!==null) {
                    if( x.composite_orgs.includes(primary_org))
                    {
                        orgs.push(this.org_name);
                    }
                }
            });
            return orgs.length;
        },
        flattenAuxOrganizations(list_of_orgs) {
            if(list_of_orgs === undefined) return '';
            if(list_of_orgs.length==0) return '';
            return list_of_orgs.map(x=>
            {
                if (x !=='None') return this.getOrganizationInfo(x).text;
            }).join(', ');

        },
        flattenLanguages(listOfLangs) {
          if (listOfLangs === undefined) return '';
          if (listOfLangs.length === 0) return '';

          return listOfLangs.map(x => {
            if (x !=='None') return this.getLanguageInfo(x);
          }).join(', ');

        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.disabled) return 'contact-disabled';
            let rowStatus = this.inContactsToUpdate(item.contact_id);
            if (rowStatus.exists) return rowStatus.color;
        },
        async getOrganization() {
            try {
                const { data } = await WardApi.getWardOrganization(this.wardId, this.organizationCode);
                this.organizationDetails = data.org;
                this.ward = data.ward;
                this.stakeId = this.ward.stake_id;
                if (this.organizationDetails.composite_orgs === null) {
                  this.organizationDetails.composite_orgs = [];
                }
                const storedOrg = this.allOrganizations.find(x=> x.org_code === this.organizationDetails.org_code);
                this.expandedCompositeOrgs = storedOrg.composite_orgs_expanded;
            } catch (e) {
                handleError(e, "Error trying to fetch organization");
            }
        },
        addForUpdate(item, action){
          var updateRequest = {
            contact_id: item.contact_id,
            org_code: this.organizationCode,
            primary_organization: item.primary_organization,
            aux_organization: item.aux_organization,
            operation: action
          }
          this.queueForUpdate(updateRequest);
        },
        traverseAndTakeAction(action) {
          // The purpose of this action is to walk and take an action
          // against the list based on the current state of the currently
          // displayed record.
          // console.log(`Running Bulk Operation: ${action}`);
          this.table.items.forEach(item => {
            // if its already selected skip this record
            if (this.inContactsToUpdate(item.contact_id).exists) {
              // console.log(`Skipping because inContactsToUpdate ${item.contact_id}`);
              return;
            }

            // lets check if this item is actionable.
            let current_state = this.alreadyBelongToOrganization(item);
            // if it's implicit skipp it
            if (current_state.implicit_belongs) {
              // console.log(`Skipping because ImplictBelongs ${item.contact_id}`)
              return;
            }
            // now lets see if the operation requested matches this contact.
            if (action==='ADD' && !current_state.already_belongs)
              this.addForUpdate(item, action);
            if (action==='REMOVE' && current_state.already_belongs)
              this.addForUpdate(item, action);
            if (action==='SWITCH' && !current_state.already_belongs)
              this.addForUpdate(item, action);

          });
        },
        alreadyBelongToOrganization(item){
          var response = {
            already_belongs: false,
            implicit_belongs: false
          }

          if (this.organizationDetails.primary) {
            if (item.primary_organization === this.organizationCode){
              response.already_belongs = true;
            }
            return response;
          }
          // so the goal here is to check if the current contact already belongs to the current selected group.
          if(this.expandedCompositeOrgs.includes(item.primary_organization)){
            response.already_belongs = true;
            response.implicit_belongs = true;
          }

          // break out because we already belong through a primary group relationship no need to check in aux
          if (response.already_belongs) return response;


          // check if we belong to through an aux organization relationship we only do 1 level though.
          item.aux_organization.forEach(x => {
            // make sure we don't belong through the composite orgs
            if (this.organizationDetails.composite_orgs!==null){
              if (this.organizationDetails.composite_orgs.includes(x)){
                response.already_belongs = true;
                response.implicit_belongs = false;
              }
            }

            // make sure we don't belong through the composite orgs
            if (this.expandedCompositeOrgs!==null) {
              if (this.expandedCompositeOrgs.includes(x)) {
                response.already_belongs = true;
                response.implicit_belongs = true;
              }
            }
          });

          // check if we belong though direct access.
          if(item.aux_organization.includes(this.organizationDetails.org_code)){
            response.already_belongs = true;
            response.implicit_belongs = false;
          }
          return response;


        },
        async sendUpdatesToServer() {
          try {
            const update_payload = {
              contact_updates: this.orgUpdates
            }
            const { data } = await OrganizationApi.updateOrganizationContacts(this.wardId, this.organizationCode, update_payload);
            let result = data;
            // clear all updates
            this.clearQueue();
            // switch back to original org
            this.orgSelected = this.organizationCode;
            // re-fetch the contacts
            this.filterWard();
            let msg = `Successfully processed ${result.total_updates} updates`;
            this.$toast.success(msg);

          } catch (e) {
            handleError(e, "Error trying to bulk update contacts");
          }
        }

    }


}
</script>
<style lang="scss">
.contact-disabled {
  color: #757575;
  background-color: #f5f5f5 !important;
}
.contact-selected {
  color: #f5f5f5;
  background-color: #42b983 !important;
}
.contact-removed {
  color: #f5f5f5;
  background-color: #efa2a2 !important;
}
.contact-changed {
  color:  #757575;
  background-color: #ecdc81 !important;
}
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>
